import { render, staticRenderFns } from "./stripeSuccess.vue?vue&type=template&id=2d8c90ef&scoped=true"
import script from "./stripeSuccess.vue?vue&type=script&lang=js"
export * from "./stripeSuccess.vue?vue&type=script&lang=js"
import style0 from "./stripeSuccess.vue?vue&type=style&index=0&id=2d8c90ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8c90ef",
  null
  
)

export default component.exports